import axios from 'axios'

let base = '/rest'

// 基本系统功能接口
//登录

// //
// export const masterSearch = params => {
//   return axios.get(`${base}/master/search`, {params: params}).then(res => res.data)
// }
// 登出
export const logout = () => {
  return axios.post(`${base}/auth/logout`)
}
// 修改密码
export const updateUserPasswoed = params => {
  return axios({
    method:'post',params,
    url: `${base}/sysUser/updateUserPasswoed`,
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js